module.exports = __webpack_public_path__ + "media/src/images/loadingSpinner-8c2bd479d87c06da137cddbb4ca705e6.png";